import type { TVolumeUserData } from 'types/user';
import { TTotalAppVolumeResponse } from 'views/types/volume';
import { create, useStore } from 'zustand';

interface IVolumesStore {
  volumeUserData: TVolumeUserData[];
  totalUsers: number;
  totalPages: number;
  totalItems: number;
  appVolumes: TTotalAppVolumeResponse | null;
}

export const volumeStore = create<IVolumesStore>((_set) => ({
  volumeUserData: [],
  totalUsers: 0,
  totalPages: 0,
  totalItems: 0,
  appVolumes: null,
}));

export const useVolumeStore = () => useStore(volumeStore);
